import { render, staticRenderFns } from "./fiveMunites.vue?vue&type=template&id=16b95919&scoped=true"
import script from "./fiveMunites.vue?vue&type=script&lang=js"
export * from "./fiveMunites.vue?vue&type=script&lang=js"
import style0 from "./fiveMunites.vue?vue&type=style&index=0&id=16b95919&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b95919",
  null
  
)

export default component.exports